/* tslint:disable */

declare var Object: any;
export interface TtadovtrequestdetailInterface {
  "requestno": string;
  "empid": string;
  "ovtdate": Date;
  "shiftdailycode": string;
  "ovttimefrom"?: Date;
  "ovttimeto"?: Date;
  "rmBefore"?: number;
  "rmAfter"?: number;
  "rmBreak1"?: number;
  "rmBreak2"?: number;
  "rmBreak3"?: number;
  "rmBreak4"?: number;
  "rmBreak5"?: number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "companyId"?: number;
  "remark"?: string;
  "cancelsts"?: string;
  ttadovtrequests?: any;
  tcltrequests?: any;
}

export class Ttadovtrequestdetail implements TtadovtrequestdetailInterface {
  "requestno": string;
  "empid": string;
  "ovtdate": Date;
  "shiftdailycode": string;
  "ovttimefrom": Date;
  "ovttimeto": Date;
  "rmBefore": number;
  "rmAfter": number;
  "rmBreak1": number;
  "rmBreak2": number;
  "rmBreak3": number;
  "rmBreak4": number;
  "rmBreak5": number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "companyId": number;
  "remark": string;
  "cancelsts": string;
  ttadovtrequests: any;
  tcltrequests: any;
  constructor(data?: TtadovtrequestdetailInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttadovtrequestdetail`.
   */
  public static getModelName() {
    return "Ttadovtrequestdetail";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttadovtrequestdetail for dynamic purposes.
  **/
  public static factory(data: TtadovtrequestdetailInterface): Ttadovtrequestdetail{
    return new Ttadovtrequestdetail(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttadovtrequestdetail',
      plural: 'Ttadovtrequestdetails',
      path: 'Ttadovtrequestdetails',
      properties: {
        "requestno": {
          name: 'requestno',
          type: 'string'
        },
        "empid": {
          name: 'empid',
          type: 'string'
        },
        "ovtdate": {
          name: 'ovtdate',
          type: 'Date'
        },
        "shiftdailycode": {
          name: 'shiftdailycode',
          type: 'string'
        },
        "ovttimefrom": {
          name: 'ovttimefrom',
          type: 'Date'
        },
        "ovttimeto": {
          name: 'ovttimeto',
          type: 'Date'
        },
        "rmBefore": {
          name: 'rmBefore',
          type: 'number'
        },
        "rmAfter": {
          name: 'rmAfter',
          type: 'number'
        },
        "rmBreak1": {
          name: 'rmBreak1',
          type: 'number'
        },
        "rmBreak2": {
          name: 'rmBreak2',
          type: 'number'
        },
        "rmBreak3": {
          name: 'rmBreak3',
          type: 'number'
        },
        "rmBreak4": {
          name: 'rmBreak4',
          type: 'number'
        },
        "rmBreak5": {
          name: 'rmBreak5',
          type: 'number'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "cancelsts": {
          name: 'cancelsts',
          type: 'string'
        },
      },
      relations: {
        ttadovtrequests: {
          name: 'ttadovtrequests',
          type: 'any',
          model: ''
        },
        tcltrequests: {
          name: 'tcltrequests',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttadovtrequestdetail.ts